import React from "react";
import loadImage from "blueimp-load-image";
import IconStore from "./IconStore";
import "./index.css";
class AddTier2 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      tier2_title: "",
      tier2_img_src: require("../../../assets/media/picture.png"),
      image_url: "",
      src: "",
      islink: false,
      url: ""
    };
  }
  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSelectImage = url => {
    this.setState({ image_url: url });
  };
  addTier2 = () => {
    const { addService } = this.props;
    const { image_url, tier2_title, islink, url } = this.state;
    this.setState({ store_visible: false });
    console.log("image_url,tier2_title", image_url, tier2_title);
    let site_url = "";
    if (islink) site_url = url;
    addService(image_url, tier2_title, site_url);
  };
  handleChangeChk = () => {
    const { islink } = this.state;
    this.setState({ islink: !islink });
  };
  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    const {
      image_url,
      tier2_img_src,
      tier2_title,
      store_visible,
      islink,
      url
    } = this.state;
    return (
      <div
        className="modal fade"
        id="add_Tier2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a new service branch</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="tier1_content">
              <label htmlFor="example-text-input">Tier2 Setting</label>
              <input
                type="text"
                name="tier2_title"
                value={tier2_title}
                className="form-control"
                placeholder="Input tier2 title.."
                onChange={this.onChange}
              />
              <button
                className="service_button"
                onClick={() => this.setState({ store_visible: true })}
              >
                <img
                  src={image_url ? image_url : tier2_img_src}
                  alt="tier2_img"
                  width="70"
                />
                <p>{tier2_title}</p>
              </button>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 10
                }}
              >
                <input
                  type="checkbox"
                  checked={islink}
                  onChange={this.handleChangeChk}
                />
                <p style={{ marginBottom: -3 }}>Is this routing a link?</p>
              </div>
              {islink && (
                <input
                  type="text"
                  name="url"
                  value={url}
                  onChange={this.onChange}
                  placeholder="https://"
                  style={{ width: "80%" }}
                ></input>
              )}
            </div>
            {store_visible && <IconStore onSelectImage={this.onSelectImage} />}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() => this.setState({ store_visible: false })}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
                onClick={() => {
                  if (tier2_title && image_url) this.addTier2();
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddTier2;



// WEBPACK FOOTER //
// ./src/screens/Chatbot/components/AddTier2.js